import * as React from "react";

function SvgIcon2(props) {
  return (
    <svg {...props} viewBox="0 0 100 100">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#62C8A5"
          d="M16 46.955L62.127 17l12.497 19.244V57l-3.655 1.952-33.183 21.55z"
        />
        <path
          fill="#EE451F"
          d="M4 51.005C4 42.718 10.709 36 19.006 36H75.01c.547 0 .99.448.99.991V95.01a.99.99 0 01-.99.991H19.006C10.718 96 4 89.292 4 80.995v-29.99z"
        />
        <path
          fill="#FF7200"
          d="M4 49.005C4 40.718 10.709 34 19.006 34H75.01c.547 0 .99.448.99.991V93.01a.99.99 0 01-.99.991H19.006C10.718 94 4 87.292 4 78.995v-29.99z"
        />
        <path
          fill="#FF9000"
          d="M54 66c0-5.523 4.475-10 10-10h19.002c.551 0 .998.455.998.992v18.016a.995.995 0 01-.998.992H64c-5.523 0-10-4.476-10-10z"
        />
        <path
          fill="#FFCD00"
          d="M54 64c0-5.523 4.475-10 10-10h19.002c.551 0 .998.455.998.992v18.016a.995.995 0 01-.998.992H64c-5.523 0-10-4.476-10-10z"
        />
        <circle cx={64} cy={64} r={5} fill="#FFF" />
        <path
          fill="#FFCD00"
          d="M0 34.115a13.272 13.272 0 010-.23c.531.076 1.073.115 1.625.115C7.907 34 13 28.907 13 22.625c0-.552-.04-1.094-.115-1.625a13.273 13.273 0 01.23 0A11.459 11.459 0 0013 22.625C13 28.907 18.093 34 24.375 34c.552 0 1.094-.04 1.625-.115a13.273 13.273 0 010 .23A11.472 11.472 0 0024.375 34C18.093 34 13 39.093 13 45.375c0 .552.04 1.094.115 1.625a13.273 13.273 0 01-.23 0c.076-.531.115-1.073.115-1.625C13 39.093 7.907 34 1.625 34c-.552 0-1.094.04-1.625.115z"
        />
        <path
          fill="#FF7200"
          d="M34 17.575a8.675 8.675 0 010-.15A7.438 7.438 0 0042.424 9a8.678 8.678 0 01.151 0A7.438 7.438 0 0051 17.424a8.675 8.675 0 010 .15A7.438 7.438 0 0042.576 26a8.675 8.675 0 01-.15 0A7.438 7.438 0 0034 17.576z"
        />
        <path
          fill="#62C8A5"
          d="M22 4.54a4.594 4.594 0 010-.08A3.938 3.938 0 0026.46 0a4.594 4.594 0 01.08 0A3.938 3.938 0 0031 4.46a4.594 4.594 0 010 .08A3.938 3.938 0 0026.54 9a4.594 4.594 0 01-.08 0A3.938 3.938 0 0022 4.54z"
        />
      </g>
    </svg>
  );
}

export default SvgIcon2;
